module.exports = __webpack_public_path__ + "img/transbank.54e2481e.jpg";